import * as api from './api';
import * as factories from './factories';
import * as schema from './validation';

export const CategoryModel = {
  ...api,
  ...factories,
  ...schema,
};
